<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3"><search-form :fields="search" /></el-button-group>

    <el-table :data="userChangeLogs" resource="user-change-logs">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column align="center" header-align="center" label="账户" width="170">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_info.level_name }})</span>
            <br>
            <span>{{ scope.row.user.mobile }}</span>
            <br>
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="log_type_text" label="类型" width="80" />
      <el-table-column prop="log_text" label="描述" />
      <el-table-column label="操作人ID" width="80">
        <template slot-scope="scope">
          <div v-if="scope.row.op_id > 0">
            <span>{{ scope.row.op_id }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="op_name" label="操作人" width="120" />
      <el-table-column prop="created_at" label="变动时间" width="170" />
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getUserChangeLogs } from '@/api/user-change-logs'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机/姓名/昵称'
        },
        {
          field: 'created_at',
          label: '获得时间',
          type: 'el-date-picker'
        }
      ],
      userChangeLogs: [],
      page: null
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        const {
          data: { data, meta }
        } = await getUserChangeLogs(newVal.query)
        this.userChangeLogs = data
        this.page = meta
      },
      immediate: true
    }
  }
}
</script>
